import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { MsiContactCardComponent } from './card.component';
import { MsiPipesModule } from '@msi/core/pipes/pipes.module';

@NgModule({
    declarations: [
        MsiContactCardComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        MsiPipesModule,
    ],
    exports: [
        MsiContactCardComponent,
        MsiPipesModule,
    ],
    providers: [],
})
export class MsiCardComponentModule { }